import React, {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import IntlMessages from '../../utility/IntlMessages';
import {LayoutType} from 'shared/constants/AppEnums';
import {useLayoutContext} from '../../utility/AppContextProvider/LayoutContextProvider';
import AppScrollbar from '../AppScrollbar';
import {red} from '@mui/material/colors';
import ThemeColors from './ThemeColors';
import ThemeFooter from './ThemeFooter';
import ThemeModes from './ThemeModes';
import ThemeDirection from './ThemeDirection';
import SidebarSettings from './SidebarSettings';
import NavStyles from './NavStyles';
import LayoutTypes from './LayoutTypes';
import ThemeHeader from './ThemeHeader';
import HelpForm from '../HelpSupportForm/HelpForm';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import './index.css';
import {useAuthUser} from '@crema/utility/AuthHooks';
import AppNotifications from '@crema/core/AppNotifications';
import {sosClicked} from 'redux/actions';
import {useDispatch} from 'react-redux';
import { position } from 'stylis';

const AppThemeSetting = () => {
  const [isSettingOpen, setSettingOpen] = useState(false);
  const [isColorSettingOpen, setColorSettingOpen] = useState(false);
  const {layoutType} = useLayoutContext();
  const {user} = useAuthUser();
  const dispatch = useDispatch();
  const CloseHelpSupport = () => {
    setSettingOpen(false);
  };
  return (
    <Box
      style={{display: ''}}
      sx={{
        position: 'fixed',

        right: 0,
        top: '50%',
        transform: "translateY('-50%')",
        zIndex: 9999999,
      }}
      className='customizerOption'
    >
      {user.role == 'CORPORATEADMIN' ||
      user.role == 'TANENTADMIN' ||
      user.role == 'VENDOR' ? (
        <>
          <Box
            sx={{
              width: '45px',
              height: '38px',
              borderTopLeftRadius: '7px',
              borderBottomLeftRadius: '7px',
              display: 'flex',
              alignTtems: 'center',
              justifyContent: 'center',
              backgroundColor: red[600],
              '&:hover': {
                backgroundColor: red[800],
              },
              '& button': {
                borderRadius: '0px 0 0 0px',

                '&:focus': {
                  borderRadius: '0px 0 0 0px',
                },
              },
              '& img': { width: '30px', height: 'auto' },
              '@media (max-height: 800px)': {
                width: '38px',
                height: '32px',
                '& img': { width: '18px' },
              },
              '@media (max-height: 700px)': {
                width: '32px',
                height: '28px',
                '& img': { width: '16px' },
              },
              '@media (max-height: 600px)': {
                width: '26px',
                height: '24px',
                '& img': { width: '14px' },
              },
            }}
          >
            <img
              onClick={() => {
                dispatch(sosClicked());
              }}
              src='/assets/images/sos2.svg'
            />
          </Box>
          <Box
            sx={{
              height: '30px',
              background: '#ff8901',
              padding: '10px',
              marginTop: '10px',
              width: '44px',
              display: 'flex',
              fontWeight: 600,
              borderTopLeftRadius: '7px',
              borderBottomLeftRadius: '7px',
              alignItems: 'center',
              cursor: 'pointer',
              justifyContent: 'center',
              right: 0,
              position: 'absolute',
              '& p': { fontSize: '20px' },
              '@media (max-height: 800px)': {
                padding: '8px',
                marginTop: '8px',
                width: '38px',
                height: '32px',
                '& p': { fontSize: '18px' },
              },
              '@media (max-height: 700px)': {
                padding: '6px',
                marginTop: '6px',
                width: '32px',
                height: '28px',
                '& p': { fontSize: '16px' },
              },
              '@media (max-height: 600px)': {
                padding: '5px',
                marginTop: '5px',
                width: '26px',
                height: '24px',
                '& p': { fontSize: '14px' },
              },
            }}
            onClick={() => setSettingOpen(!isSettingOpen)}
          >
            <p
              style={{
                // transform: 'rotate(-270deg)',
                color: 'white',
              }}
            >
              {/* Help & Support */}?
            </p>
            {/* <IconButton>
              {
                <p
                  style={{
                    transform: 'rotate(-270deg)',
                    color: 'white',
                    width: '1px',
                  }}
                >
                  Contact Support
                </p>
              }
              <SupportAgentIcon
                sx={{
                  animation: 'rotation 2s infinite linear',
                  color: 'white',
                }}
              />
              <SupportAgentIcon />
            </IconButton> */}
          </Box>
        </>
      ) : null}
      {/* <Box
        sx={{
          borderRadius: '30px 0 0 30px',
          backgroundColor: red[500],
          '&:hover': {
            backgroundColor: red[700],
          },
          '& button': {
            borderRadius: '30px 0 0 30px',

            '&:focus': {
              borderRadius: '30px 0 0 30px',
            },
          },
        }}
      >
        <IconButton onClick={() => setColorSettingOpen(!isSettingOpen)}>
          <ColorLensIcon
            sx={{
              color: 'white',
            }}
          />
        </IconButton>
      </Box> */}
      <Drawer
        anchor='right'
        sx={{
          '& .MuiBackdrop-root': {
            background: 'transparent',
          },
        }}
        className={layoutType === LayoutType.BOXED ? 'boxed-drawer' : ''}
        open={isSettingOpen}
        onClose={() => setSettingOpen(false)}
      >
        <AppScrollbar
          sx={{
            width: {xs: 300, md: 360, xl: 400},
          }}
        >
          <Box
            sx={{
              padding: {xs: '20px', xl: '28px 22px'},
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box
              component='h3'
              mb={0.5}
              fontSize={18}
              style={{textAlign: 'center'}}
            >
              Help and Support
              {/* <IntlMessages id='customizer.customiseSidebar' /> */}
            </Box>
            <Box
              component='p'
              mb={0}
              color='text.secondary'
              style={{textAlign: 'center'}}
            >
              Please submit your query here
              {/* <IntlMessages id='customizer.customiseSidebarText' /> */}
            </Box>
          </Box>
          <Box
            sx={{
              padding: {xs: '20px', xl: '28px 22px'},
            }}
          >
            {/* <div style={{fontWeight:"bolder", color:"#9b9595", textAlign:"center", paddingTop:"90%"}} >Coming Soon</div> */}
            <HelpForm close={CloseHelpSupport} />
            {/* <NavStyles />
            <LayoutTypes />
            <ThemeDirection />
            <ThemeHeader />
            <ThemeFooter />
            <SidebarSettings /> */}
          </Box>
        </AppScrollbar>
      </Drawer>
      <Drawer
        anchor='right'
        open={isColorSettingOpen}
        onClose={() => setColorSettingOpen(false)}
        sx={{
          '& .MuiBackdrop-root': {
            background: 'transparent',
          },
        }}
        className={layoutType === LayoutType.BOXED ? 'boxed-drawer' : ''}
      >
        <AppScrollbar
          sx={{
            width: {xs: 300, md: 360, xl: 400},
          }}
        >
          <Box
            sx={{
              padding: {xs: '20px', xl: '28px 22px'},
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box component='h3' mb={0.5} fontSize={18}>
              <IntlMessages id='customizer.customiseTheme' />
            </Box>
            <Box component='p' mb={0} color='text.secondary'>
              <IntlMessages id='customizer.customiseText' />
            </Box>
          </Box>
          <Box
            sx={{
              padding: {xs: '20px', xl: '28px 22px'},
            }}
          >
            <ThemeModes />
            <ThemeColors />
          </Box>
        </AppScrollbar>
      </Drawer>
    </Box>
  );
};

export default AppThemeSetting;
